import * as storageApi from 'resources/storage/storage.api';


export const uploadFile = async ({ bucket, file, path }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('bucket', bucket);
  formData.append('path', path);

  await storageApi.upload(formData);
};

export const copyFile = async ({ bucket, fromPath, toPath }) => {
  await storageApi.copy({ bucket, fromPath, toPath });
};

export const removeFile = async ({ bucket, path }) => {
  await storageApi.remove({ bucket, path });
};

export const downloadFile = async ({ bucket, path }) => {
  const response = await storageApi.download({ bucket, path });
  const buffer = Buffer.from(response.data);
  const blob = new Blob([buffer], { type: response.contentType });

  return blob;
};

export const getSignedUrl = async ({ path, bucket }) => {
  const signedUrl = await storageApi.getSignedUrl({ bucket, path });
  return signedUrl;
};

export const getAvatarUrl = async (url) => {
  try {
    const signedUrl = await getSignedUrl({ bucket: 'avatars', path: url });
    return signedUrl;
  } catch (error) {
    console.error('Error getting avatar url', error);
    return null;
  }
};

export const getPublicUrl = async ({ bucket, path }) => {
  const publicUrl = await storageApi.getPublicUrl({ bucket, path });
  return publicUrl;
};

export const getAgreementFileUrl = async (fileName) => {
  const publicUrl = await getPublicUrl({ bucket: 'agreements', path: fileName });
  return publicUrl;
};

export const getProductTourFileUrl = async (fileName) => {
  const publicUrl = await getPublicUrl({ bucket: 'product-tour', path: fileName });
  return publicUrl;
};

export const uploadFileAndGetPublicUrl = async ({ bucket, file, path }) => {
  await uploadFile({ bucket, file, path });
  
  const publicUrl = await getPublicUrl({ bucket, path });
  return publicUrl;
};
